import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { RequisitosAcademicosDTO } from '../../../../core/models/titulacion/requisitosAcademicos-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class RequisitosAcademicosService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getRequisitosAcademicosService() {
        return this.http.get<BodyListResponse<RequisitosAcademicosDTO>>(
            API_URL + '/api/v1/requisitosAcademicos/todos'
        );
    }

    guardarRequisitosAcademicosService(requisitosAcademicosDTO: RequisitosAcademicosDTO) {
        return this.http.post(API_URL + '/api/v1/requisitosAcademicos', requisitosAcademicosDTO);
    }

    getRequisitosAcademicosPorCodigoRequisitoAcademicoService(codigoRequisitoAcademico: string) {
        return this.http.get<BodyResponse<RequisitosAcademicosDTO>>(
            API_URL + '/api/v1/requisitosAcademicos/' + codigoRequisitoAcademico
        );
    }
}
